import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { PageHero } from '../components/ui/PageHero';
import { LazyMap } from '../components/ui/LazyMap';
import { SERVICE_AREAS, COMPANY } from '../lib/site';
import { Reveal } from '../components/fx/Reveal';
import { MagneticButton } from '../components/fx/MagneticButton';
import { EmergencyCTA } from '../components/sections/EmergencyCTA';
const houstonAreaEmbedUrl = 'https://www.openstreetmap.org/export/embed.html?bbox=-96.0%2C29.4%2C-94.9%2C30.2&layer=mapnik&marker=29.7604%2C-95.3698';
const houstonMapsUrl = 'https://www.google.com/maps/search/?api=1&query=Houston%2C%20Texas';
export function ServiceAreas() {
  return <>
      <PageHero eyebrow="Where We Work" title="Serving Houston & Beyond" subtitle="Fast, reliable restoration and construction across the greater Houston metro area." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Service Areas'
    }]} data-id="element-510" data-mp="1bcpq1dec13xj" />

      <section className="deferred-section mx-auto max-w-6xl px-6 py-8" data-id="element-511" data-mp="30e9r783voaox">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-512" data-mp="30cyjix7baisj">
          {SERVICE_AREAS.map((area, index) => <Reveal key={area} delay={index * 0.05} data-id="element-513" data-mp="2qgvjbww0su88" data-mpi={index}>
              <motion.div whileHover={{
            y: -4
          }} className="glass-strong flex items-center gap-4 rounded-3xl p-6 shadow-glass" data-id="element-514" data-mp="2qgdhmkql9nsx">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-royal/10 text-royal" data-id="element-515" data-mp="2gopkq4b9jek2">
                  <MapPinIcon className="h-6 w-6" data-id="element-516" data-mp="2cmumx9sjjjb1" />
                </span>
                <div data-id="element-517" data-mp="27rypfu4jc3qj">
                  <p className="font-display text-lg font-bold text-navy" data-id="element-518" data-mp="27oaz13udzxg1">
                    {area}
                  </p>
                  <p className="text-xs text-slate" data-id="element-519" data-mp="1xrfzqiqaht0p">
                    & surrounding neighborhoods
                  </p>
                </div>
              </motion.div>
            </Reveal>)}
          <Reveal delay={0.5} data-id="element-520" data-mp="1t3yfxaq8vmkl">
            <div className="flex h-full flex-col items-start justify-center gap-3 rounded-3xl bg-royal p-6 text-white shadow-glow" data-id="element-521" data-mp="1t488n62oc7tz">
              <p className="font-display text-lg font-bold" data-id="element-522" data-mp="1f60c2z9jv8jc">
                Don't see your area?
              </p>
              <p className="text-sm text-white/80" data-id="element-523" data-mp="26v3hwjh34qy3">
                We likely serve you too. Give us a call.
              </p>
              <a href={COMPANY.phoneHref} className="mt-1 inline-flex items-center gap-2 text-sm font-semibold underline" data-id="element-524" data-mp="2bu6f5hqtpsvi">
                <PhoneIcon className="h-4 w-4" data-id="element-525" data-mp="223v83mbuf3ke" /> {COMPANY.phoneDisplay}
              </a>
            </div>
          </Reveal>
        </div>

        <Reveal className="mt-10 overflow-hidden rounded-[2.5rem] shadow-glow" data-id="element-526" data-mp="2psmrbo7ggbl1">
          <LazyMap title="Houston service area map" embedUrl={houstonAreaEmbedUrl} mapsUrl={houstonMapsUrl} className="h-96 w-full" data-id="element-527" data-mp="2uko2f6svzw9h" />
        </Reveal>

        <Reveal className="mt-12 flex justify-center" data-id="element-528" data-mp="e5ay4r6cenl7">
          <MagneticButton variant="primary" to="/contact" data-id="element-529" data-mp="e4hwg4m8qo9x">
            Schedule Free Inspection
          </MagneticButton>
        </Reveal>
      </section>

      <EmergencyCTA data-id="element-530" data-mp="nxgmlqxdymvn" />
    </>;
}